<template>
  <div class="flex-table">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'FlexTable',
  }
</script>

<style lang="scss">
  .flex-table {
    display: inline-flex;
    flex-wrap: wrap;
  }

  .flex-tcol {
    display: inline-flex;
    flex-direction: column;
  }

  .flex-trow {
    display: inline-flex;
    flex-direction: row;
    min-height: $table-row-min-height;
    width: 100%;
    &.flex-trow-header {
      min-height: unset;
      height: 100%;
    }
  }

  .flex-th, .flex-td {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-grow: 1;
    flex-basis: 100%;
    overflow-x: hidden;
    margin: -0.5px;
    padding: $table-cell-padding;
  }

  .flex-th {
    font-weight: bold;
    justify-content: center;
    border: 1px solid rgba($gray-900, 0.1);
    background-color: rgba($dark-blue, 0.1);
  }

  .flex-td {
    border: 1px solid rgba($gray-900, 0.1);
  }

  .table-title {
    background-color: $table-title-background-color;
    color: $white;
    border-radius: 10px 10px 0 0;
    font-size: $font-size-base*1.125;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .num-cell {
    width: $num-cell-width;
    flex-basis: $num-cell-width;
    flex-grow: 0;
    flex-shrink: 0;
    justify-content: center;
    flex-direction: column;
    line-height: 1;
  }

  .editable-cell {
    padding: 0;

    & input {
      padding: $table-cell-padding;
    }
  }
</style>